import { render, staticRenderFns } from "./CpyAdd.vue?vue&type=template&id=6c75a94b&scoped=true"
import script from "./CpyAdd.vue?vue&type=script&lang=js"
export * from "./CpyAdd.vue?vue&type=script&lang=js"
import style0 from "./CpyAdd.vue?vue&type=style&index=0&id=6c75a94b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c75a94b",
  null
  
)

export default component.exports